module.exports = __webpack_public_path__ + "media/images/no_image-9792ff22dce78b0fc4897aa5077a3c3d.jpg";